module.exports = __webpack_public_path__ + "img/icon-4.de7b94f7.png";